import "./EditSiteNotes.html";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import EditSiteNotesComponentController from "./EditSiteNotesComponentController";

export default class EditSiteNotesComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            resolve: "<",
        };
        this.controller = EditSiteNotesComponentController;
        this.templateUrl = "/App/Components/Site/Overview/Notes/EditSiteNotes/EditSiteNotes.html";
    }
}

module("mmManagePortal").component("mmEditSiteNotes", new EditSiteNotesComponent());
